import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, PageHeader, Spinner, Badge } from "@/components/ui";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Cell } from "recharts";

export default function QualityManagement() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/quality-measures").then((r) => setItems(r.data)); }, []);
  if (!items) return <Spinner />;

  const chartData = items.map((q) => ({ name: q.measure_id, rate: q.rate, target: q.target }));
  const aboveTarget = items.filter((q) => q.status === "Above Target").length;

  return (
    <div className="vc-fade-up">
      <PageHeader title="Quality Management" subtitle={`NCQA / HEDIS-aligned quality measures. ${aboveTarget} of ${items.length} measures at or above target.`} />

      <Card className="p-6 mb-4">
        <h3 className="font-display font-semibold text-lg mb-4">Measure Performance vs. Target</h3>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={chartData} barGap={2}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#eef2f6" />
            <XAxis dataKey="name" tick={{ fontSize: 11 }} />
            <YAxis tick={{ fontSize: 11 }} domain={[0, 100]} />
            <Tooltip />
            <Bar dataKey="rate" name="Current Rate" radius={[4, 4, 0, 0]}>
              {chartData.map((d, i) => <Cell key={i} fill={d.rate >= d.target ? "#4f46e5" : "#dc2626"} />)}
            </Bar>
            <Bar dataKey="target" name="Target" radius={[4, 4, 0, 0]} fill="#cbd5e1" />
          </BarChart>
        </ResponsiveContainer>
      </Card>

      <Card className="overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="border-b border-border text-left text-xs uppercase tracking-wider text-muted-foreground">
              <th className="px-4 py-3 font-semibold">Measure</th><th className="px-4 py-3 font-semibold">Name</th>
              <th className="px-4 py-3 font-semibold">Domain</th><th className="px-4 py-3 font-semibold text-right">Rate</th>
              <th className="px-4 py-3 font-semibold text-right">Target</th><th className="px-4 py-3 font-semibold">Denominator</th>
              <th className="px-4 py-3 font-semibold">Status</th></tr></thead>
            <tbody className="divide-y divide-border">
              {items.map((q) => (
                <tr key={q.id} className="hover:bg-muted transition-colors">
                  <td className="px-4 py-3 font-mono text-xs font-semibold">{q.measure_id}</td>
                  <td className="px-4 py-3 font-medium">{q.name}</td>
                  <td className="px-4 py-3 text-muted-foreground">{q.domain}</td>
                  <td className="px-4 py-3 text-right font-mono font-semibold">{q.rate}%</td>
                  <td className="px-4 py-3 text-right font-mono text-muted-foreground">{q.target}%</td>
                  <td className="px-4 py-3 font-mono text-muted-foreground">{q.denominator.toLocaleString()}</td>
                  <td className="px-4 py-3"><Badge tone={q.status}>{q.status}</Badge></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
